import { createStyles, Drawer } from '@mantine/core';
import { memo } from 'react';
import type { IAiChat } from '../../../api/hooks/aiChats';
import { AiChatDrawerContent } from './AiChatDrawerContent';

interface AiChatDrawerProps {
	opened: boolean;
	onClose: () => void;
	chatId: string | null;
	selectedChat: IAiChat | null;
}

const useStyles = createStyles((theme) => ({
	drawerBody: {
		width: '100%',
		height: '100%',
		overflowY: 'auto',
		display: 'flex',
		padding: 0,
	},
	overlay: {
		backgroundColor: theme.other.getColor('surface/backdrop/default'),
	},
}));

export const AiChatDrawer = memo(
	({ opened, onClose, chatId, selectedChat }: AiChatDrawerProps) => {
		const { classes } = useStyles();

		return (
			<Drawer
				classNames={{
					body: classes.drawerBody,
					overlay: classes.overlay,
				}}
				position="right"
				opened={opened}
				onClose={onClose}
				size={640}
				withinPortal
				withCloseButton={false}
			>
				{(chatId || selectedChat) && (
					<AiChatDrawerContent
						chatId={chatId}
						selectedChat={selectedChat}
						onClose={onClose}
					/>
				)}
			</Drawer>
		);
	}
);
